import React from 'react';
import './InfoTile.css';
import { BsDownload } from 'react-icons/bs';
import { AiOutlineClose } from 'react-icons/ai';
import Button from 'react-bootstrap/Button';
import {Link, useLocation} from 'react-router-dom';
import { BiLinkAlt } from 'react-icons/bi';


const InfoTile = (props) => {
    console.log(props)
    let content =null;
    const  search  = useLocation();
    const creator_url = (name) => name.replaceAll(" ","_");
    let search_link = search.pathname.split('/id')[0];

    if (props.link !== ""){
        content = (<a href={props.link} rel="noreferrer" target="_blank"> 
        <BiLinkAlt />
    </a>)
    }

    return (
        <div className="InfoTile">
            <h2> {props.name} </h2> 
            <Link to={"../"+search_link}>
                <Button  variant="outline-secondary" size="sm" className="CloseButton">
                    <AiOutlineClose />
                </Button>
            </Link>
            


            <div className="StickPicDiv" >
                <img className="StickPicInfo" src= {props.pic} alt={props.name}/>
            </div>
            <div className="StickInfoDiv" >
                
                <p className="InfoText">Creator: <Link to={'/c='+ creator_url(props.creator)} creatorId={ props.creator} onClick={props.creatorclick} >{props.creator}</Link> {content} </p>
                <p className="InfoText">Category: {props.category} </p>
                <p className="InfoText">Pivot version: {props.version} </p>
                <p className="InfoText">File type: {props.file} </p>
                <p className="InfoText">Detail: {props.detail} </p>

                <a href={props.stk} download>
                    <Button  variant="outline-secondary" size="sm" className="DownloadButton">
                        Download <BsDownload />
                    </Button>
                </a>
            </div>

        </div>
    )
};

export default InfoTile;
